// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Import Firebase Auth
import { getFirestore } from "firebase/firestore"; // Import Firestore

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA2ojFXWsm6lO4LgH4JlFeOCCkzn67MtVs",
  authDomain: "bingo-website-5fafe.firebaseapp.com",
  projectId: "bingo-website-5fafe",
  storageBucket: "bingo-website-5fafe.firebasestorage.app",
  messagingSenderId: "1081876199974",
  appId: "1:1081876199974:web:dbd64fe911b1474a15c4e7",
  measurementId: "G-SJ7EMKE2MZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

// Test Firebase connection
console.log("Firebase has been initialized successfully!");

export { auth, db, analytics };